import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import useFetchUserSettings from "../userHooks/useFetchUserSettings";
import languageUtil from "../../utls/LanguageUtil";

/**
 * Hook to synchronize i18n language with user settings
 * This ensures that the app language matches the user's preferred language from the database
 */
const useLanguageSync = () => {
  const { i18n } = useTranslation();
  const { currentUserSettings } = useFetchUserSettings();
  const hasSynced = useRef(false);

  useEffect(() => {
    const syncLanguage = async () => {
      // Only sync once when userSettings are loaded
      if (!currentUserSettings || hasSynced.current) {
        return;
      }

      const preferredLang = currentUserSettings.preferredLang;
      const currentI18nLang = i18n.language?.split("-")[0];

      // If user has a preferred language and it's different from current i18n language
      if (preferredLang && preferredLang !== currentI18nLang) {
        await languageUtil.setCurrentLanguage(i18n, preferredLang);
        hasSynced.current = true;
      } else if (preferredLang) {
        // Even if languages match, ensure localStorage is in sync
        await languageUtil.setCurrentLanguage(i18n, preferredLang);
        hasSynced.current = true;
      }
    };

    syncLanguage();
  }, [currentUserSettings, i18n]);
};

export default useLanguageSync;
